<template>
	<vue-line
    :mouseEvents="['mouseover']"
    v-on:mouseover="$emit('mouseover')"
  >
  	<vue-item>
      {{ segment.name }}
    </vue-item>

		<vue-item>
      <template v-if="segment.date_raw">
        {{ segment.date_raw | moment('LL') }}
      </template>
    </vue-item>

    <vue-item align="right">
      {{ segmentWs }}
    </vue-item>

    <vue-item align="right">
      {{ segmentTraffic }}
    </vue-item>

    <vue-item align="right">
      {{ segmentCount }}
    </vue-item>

    <vue-item align="right">
      <vue-element
        v-if="visibleCompare"
        type="label"
        :data="comparisonData.transactions"
        labelNote="X"
      />
      <template v-else>
        {{ transactions }}
      </template>
    </vue-item>

    <vue-item align="right">
      {{ conversion }}
    </vue-item>

    <vue-item align="right">
      <vue-element
          v-if="visibleCompare"
          type="label"
          :data="comparisonData.transaction_revenue"
          labelNote="X"
      />
      <template v-else>
        {{ transaction_revenue }}
      </template>
    </vue-item>

		<vue-item class="segment_action" align="center">
      <div class="table-line__actions">
        <v-button
          v-bind="{
            height: '32px',
            type: 'text-base',
            paddingLeft: '6px',
            paddingRight: '6px',
            to: { query: routeDelete.query }
          }"
          v-tippy
          :content="$t(contentPath)['Remove this segment from the comparison']"
        >
          <icon
            v-bind="{
              name: 'delete',
              fill: '#9D99AA'
            }"
          />
        </v-button>
      </div>
    </vue-item>
	</vue-line>
</template>

<script>
import {roundNumber, generateRoute} from '@/function'

export default {
  props: {
    segment: {
      type: Object,
      default: function () {
        return {}
      }
    },

    activeSegment: {
      type: Object
    },

    searchSystem: {
      type: String,
      default: 'yandex'
    },

    activeSalesMetric: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  data () {
    const contentPath = 'services.bi.comparison'

    return {
      contentPath
    }
  },

  computed: {
    routeDelete () {
      let newRoute = generateRoute(this.$route)

      return this.deleteParam({
        route: newRoute,
        type: this.segment.type,
        id: this.segment.id
      })
    },

    visibleCompare () {
      return this.activeSegment && this.activeSegment.id !== this.segment.id
    },

    segmentWs () {
      return this.formatCount(this.segment.ws)
    },

    segmentTraffic () {
      return this.formatCount(this.segment[this.searchSystem].traffic)
    },

    segmentCount () {
      return this.formatCount(this.segment.count)
    },

    transactions () {
      return this.formatCount(this.segment[this.searchSystem].transactions)
    },

    transaction_revenue () {
      return this.formatCount(this.segment[this.searchSystem].transaction_revenue)
    },

    conversion () {
      return this.formatCount(this.segment[this.searchSystem].conversion, '%')
    },

    comparisonData () {
      const comparisonFormula = (name) => {
        return roundNumber((this.segment[this.searchSystem][name] - this.activeSegment[this.searchSystem][name]) / this.activeSegment[this.searchSystem][name], 1) || 0
      }

      return {
        transaction_revenue: comparisonFormula('transaction_revenue') || 0,
        transactions: comparisonFormula('transactions') || 0
      }
    }
  },

  methods: {
    formatCount (count, label = '') {
      if (count !== null && count !== undefined) {
        return count.toLocaleString(undefined) + label
      } else if (count === 0 || !!count) {
        return count + label
      }
    },

    deleteParam ({ route, type, id }) {
      try {
        const activeFilter = route.query[`${type}_id`]

        if (Array.isArray(activeFilter)) {
          const index = route.query[`${type}_id`].indexOf(String(id))
          if (index > -1) {
            route.query[`${type}_id`].splice(index, 1)
          }
        } else {
          route.query[`${type}_id`] = undefined
        }
      } catch (_) {}

      return route
    }
  }
}
</script>
